import { $util, guid } from '@/util/util';
/**
 * toast pc、wap通用
 * @param {String} msg 提示文案,msg为空默认不展示
 * @param {Number} time  提示展示时长,ms
 * @param {Boolean} destory 是否清除之前toast,默认不清除
 * eg: 
 * Toast('提示文案', 1000, true) || Toast.once('提示文案', 1000)
 */
const toast = (msg = '', time = 2000, destory = false) => {
  if(!msg) return;
  const randomID = guid();
  const isPC = $util.isPC();
  const commonClass = '_comp_toast_traditional';
  const uniqueClass = `_comp_toast_traditional_${randomID}`;
  const html = `
      <div
      class='${commonClass} ${uniqueClass}'
      style="
          position: fixed;
          top: 50%;
          left: 50%;
          background-color: rgba(0,0,0,0.6);
          color: #fff;
          padding: ${isPC ? '10px' : '0.16rem 0.2rem'};
          border-radius: ${isPC ? '7px' : '0.07rem'};
          z-index: 99999;
          font-size: ${isPC ? '16px' : '0.16rem'};
          transform: translate(-50%, -50%);
          text-align: left;
          max-width: ${isPC ? '500px' : '60%'};
      ">
      ${msg}
      </div>
  `;
  if(destory) {
      document.querySelectorAll(`.${commonClass}`).forEach(dom => dom.remove());
  }
  $('body').append(html)
  setTimeout(() => {
      document.querySelector(`.${uniqueClass}`).remove();
  }, time);
}
toast.once = function(msg = '', time = 2000) {
  toast(msg, time, true);
}

export default toast;
